// extracted by mini-css-extract-plugin
module.exports = {"root":"InvalidShareLink_root__iGy8h"};